module.exports = __webpack_public_path__ + "static/media/opinion_down.c9ffe1f6.svg";